import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap/nav';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { LessonHelpComponent } from '../../lesson/shared/lesson-help/lesson-help.component';

@Component({
    selector: 'app-exercise-strategy',
    templateUrl: './exercise-strategy.component.html',
    styleUrls: ['./exercise-strategy.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, FormsModule, RouterLink, NgbNavOutlet, LessonHelpComponent]
})
export class ExerciseStrategyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
